import { RewardProgressProps } from 'shared/interfaces/reward-progress/reward-progress.interface';
/**
 * Checks if the points balance is greater than or equal to the points needed for the reward.
 * @param rewardProgress - The reward progress.
 * @returns True if the points balance is greater than or equal to the points needed for the reward, false otherwise.
 */
export const checkIfRewardProgressIsComplete = (rewardProgress?: RewardProgressProps | null) => {
  if (!rewardProgress?.points || !rewardProgress?.targetPointsForReward) {
    // If points balance or points needed for reward is not provided, return false
    return false;
  }

  return (
    // If previous points is not provided, or if previous points is less than the target points for reward, return false
    (!rewardProgress.previousPoints || rewardProgress.previousPoints < rewardProgress.targetPointsForReward) &&
    rewardProgress.points >= rewardProgress.targetPointsForReward
  );
};
